import React from "react";
import PermisosEspaciales from "./PermisosEspaciales.jsx";

const PermisosEspacialesLista = (props) => {
    let permisoNodes;
    let showMessage = false;

    if (props.permisosParaMostrar && props.permisosParaMostrar.length > 0) {
        permisoNodes = props.permisosParaMostrar.map(function (p, index) {
            return (<PermisosEspaciales data={p} key={index} />)
        });
    } else {
        showMessage = true;
        permisoNodes = (<div className="col-xs-12">
            <p>No tiene permisos y restricciones especiales asignados</p>
        </div>);
    }

    return (
        <div className="row">
            <div className="col-xs-12">
                <h3 className="divisor-section">Permisos y restricciones especiales</h3>
            </div>
            {showMessage == false ?
                <div className="col-xs-12">
                    <ul className="list-unstyled">{permisoNodes}</ul>
                </div> : permisoNodes}
        </div>
    );
}

export default PermisosEspacialesLista;
